import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/pendapatan/transaksi/:bayar(\\d+)?/:lokasi(\\d+)?/:loket(\\d+)?',
    name: 'pendapatan-transaksi',
    component: () => lazyLoadView(import('@views/admin/pendapatan/transaksi/List.vue')),
    meta: {
      title: 'Pencatatan Pendapatan',
    },
  },
  {
    path: '/:operator/:id(\\d+)/pendapatan/transaksi/detail/:pendapatan_id(\\d+)/:bayar(\\d+)?/:lokasi(\\d+)?/:loket(\\d+)?',
    name: 'pendapatan-detail',
    component: () => lazyLoadView(import('@views/admin/pendapatan/transaksi/Detail.vue')),
    meta: {
      title: 'Detail Pencatatan Pendapatan',
    },
  },
  {
    path: '/:operator/:id(\\d+)/pendapatan/laporan/:tahun?/:bulan?/:hari?/:bayar?/:lokasi?/:loket?',
    name: 'pendapatan-laporan',
    component: () => lazyLoadView(import('@views/admin/pendapatan/laporan/List.vue')),
    meta: {
      title: 'Laporan Pendapatan',
    },
  },
];
